import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import AddSidebar from './add-sidebar';
@inject('songsStore', 'formStore', 'albumsStore')
@observer
class NewSongModal extends Component {
	render () {
		const { rowUserID, artist } = this.props;

		return (
			<div>
				<AddSidebar artist={ artist } rowUserID={rowUserID}/>
				<button
					style={{width: '12vw'}}
					className="add-button button"
					onClick={ this.handleOpenModal }
				>
					<span className="icon fi-plus"></span> Submit Music
				</button>
			</div>
		);
	}

	@autobind
	handleOpenModal () {
		const { songsStore, artist } = this.props;

		// Creates and returns new song to edit, adding it to the songlist and causes the modal to open
		songsStore.songToEdit = songsStore.newSong({
			artistID: artist.id
		});
	}

	@autobind
	handleCloseModal () {
		// Setting this to null will close the modal
		this.props.songsStore.songToEdit = null;
	}
}

export default NewSongModal;
